import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Permission } from "../permissions/permission.enum";

interface PermissionRouteProps {
  permission: Permission;
  redirectPath?: string;
  children?: React.ReactNode;
}

const PermissionRoute: React.FC<PermissionRouteProps> = ({
  permission,
  redirectPath = "/forbidden",
  children,
}) => {
  const { hasPermission, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (!hasPermission(permission)) {
    return <Navigate to={redirectPath} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default PermissionRoute;
